import { motion } from "framer-motion";

export const hyGraphToken = `eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MjAwMTUzMjYsImF1ZCI6WyJodHRwczovL2FwaS11cy13ZXN0LTIuaHlncmFwaC5jb20vdjIvY2x3ajZsbHZjMDBwbTA3dngxMTByeDJqYi9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC11cy13ZXN0LTIuaHlncmFwaC5jb20vIiwic3ViIjoiM2U4MmEwYWMtZDg0My00MGVlLTliNTMtODRkNmEzZjg2OGM0IiwianRpIjoiY2x5NXdwcnRzMDRsajA3bjNmdnQ3NXlkdyJ9.pBwN2I51U9LX4Bjswwmjrgut5u1x4zSZ9RZgWyiwNYJOmRjJ4sDXHmaUom40oJxFgz1RhfDJlwWIGB1GrzH20oskBHvmG0skozJ86eAY368AyTtnu7n-6ZZPhppL_36AT_jzF9YWN1VgEhIrzMUSlULp7_mH8wXEKf0DFlYbhJ-xUElhds_5ORaRW4DLgrrD1xldjvh5ViDRJIYjUegtUepuxcAqtT2kyFdNcLhk5gs4mHS22sARDAT75t-34Lv1UQi0ru8gJzkfuXD24iRCI-tcPvMFenxV_cw7MLq4saWN3owkONOa9X-nHlg3bC1Gjw_y4BH9O5biktoeCTFiGTkjewy25onVvS2HSBSquCLhSQFPP_oKqJHfdZaTP5Cz9mEfRGGl5CxhMD7n_wnWDG4iA_gnWHwOPPl7vChO2V3OhFUYh0cc89ornEj3y0awqKB6M78O6eLPpOc9xuq8WnhbIeZgDzfgv1hRiJj0UnewKbZzJq6yXobsmiwgnDP005eInqns49L4Rn04Ahw8bZ787S5JmuvsriMlkATnuq7oNv8Jn58Hk7HeuHWAkENZNNCCxY3yaclpDI3kuasxgi5WixUxSSb0v4Rxmqk8zccuNFRZ_VvKJo40wQuPGlKHdwhlpJnbp8OF8rndD7N8_os34daOfr1vuvXx13ld-Hg`

export const endpointURL = `https://api-us-west-2.hygraph.com/v2/clwj6llvc00pm07vx110rx2jb/master`

export  const AnimatedParagraph = ({ children, className }) => {
    return (
      <motion.p  initial={{ y: 100, opacity: 0 }}
      whileInView={{ x: -0, y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{
        type: "spring",
        duration: 2,
      }}
      className={className}
      >
        {children}
      </motion.p>
    );
  };


//Date Formate
export  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  };